import { ThunderboltOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { SettingsSection } from "./SettingsSection";

/**
 * Секцията „Поддръжка" с единствения ред-действие на страницата —
 * „Оптимизация с база" (трие сметките без бон, преномерира ги без дупки и
 * зачиства историята на касите). Същият ред като
 * настройките (име + описание вляво), но вдясно вместо превключвател стои
 * danger бутон; модалите за потвърждение и резултат ги държи страницата.
 */
export function CleanupSection({
  onRun,
  running,
  offline = false,
}: {
  onRun: () => void;
  running: boolean;
  /** Локален режим — операцията изисква облака и всяка каса (виж hint-а). */
  offline?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <SettingsSection
      kicker={t("orderingSettings.sectionMaintenanceKicker")}
      title={t("orderingSettings.sectionMaintenanceTitle")}
      count={1}
    >
      <div className="grid gap-3 px-5 py-4 @2xl:grid-cols-[minmax(0,1fr)_minmax(0,1.15fr)] @2xl:gap-8">
        <div className="min-w-0">
          <div className="text-[13.5px] font-bold tracking-[-0.2px] text-ink">
            {t("nonFiscalDisplay.cleanupTitle")}
          </div>
          <div className="mt-1 text-[12.5px] leading-[1.45] text-muted">
            {t("nonFiscalDisplay.cleanupDesc")}
          </div>
        </div>
        <div className="min-w-0">
          <button
            type="button"
            onClick={onRun}
            disabled={running || offline}
            className="inline-flex h-9 items-center justify-center gap-2 rounded-[10px] border-none bg-danger px-4 text-[13px] font-bold tracking-[-0.2px] text-white transition-[background] duration-150 enabled:cursor-pointer enabled:hover:bg-danger/90 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {running ? (
              <span className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-white/50 border-t-white" />
            ) : (
              <ThunderboltOutlined className="text-[13px]" />
            )}
            {t("nonFiscalDisplay.cleanupRun")}
          </button>
          <div className="mt-2.5 text-[12.5px] leading-[1.45] text-soft">
            {t(
              offline
                ? "nonFiscalDisplay.cleanupOfflineHint"
                : "nonFiscalDisplay.cleanupHint",
            )}
          </div>
        </div>
      </div>
    </SettingsSection>
  );
}
